
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({
    showSpinner: false
});

class LoadingProgress {

    private counter: number = 0;

    public start(): LoadingProgress {

        if (1 === this.inc()) {
            NProgress.start();
        }

        return this;
    }


    public stop(): LoadingProgress {
        if (0 === this.dec()) {
            NProgress.done();
        }

        return this;
    }

    private inc(): number {
        return ++this.counter;
    }

    private dec(): number {
        --this.counter;

        if (0 > this.counter) {
            this.counter = 0;
        }

        return this.counter;
    }
}

export default new LoadingProgress();
